import { IPerformanceTeamMemberOverviewQuery } from '../interfaces/performance-team-member-overview.query.interface';

// @dynamic
export class PerformanceTeamMemberOverview {
    status: string;
    count: number;

    constructor(query: IPerformanceTeamMemberOverviewQuery) {
        this.status = query.status;
        this.count = query.count;
    }
}
